import './blocks.less'

import React, {HTMLProps} from 'react'
import {style} from 'util/style'

const styles = style('blocks')

export const Blocks: React.FC<HTMLProps<HTMLDivElement>> = ({
	children,
	...props
}) => <div className={styles().mergeProps(props)}>{children}</div>
